<template>
	<!-- Container -->
	<div class="pt-5 flex flex-col gap-y-12 justify-center items-center container mx-auto">
		<h1 class="px-4 text-primary self-start text-4xl font-serif">ROMA Kundenkarte</h1>
		<div class="order-1 lg:order-0 px-4 grid grid-cols-1 md:grid-cols-2 gap-6">
			<div class="flex flex-col gap-y-2">
				<p class="text-lg font-bold text-primary">Wieso Du Dir jetzt gleich eine ROMA Kundenkarte holen solltest?</p>
				<p>Damit sich Deine Treue noch mehr auszahlt! Denn bei Vorlage Deiner persönlichen Kundenkarte beim Shoppen in unseren österreichischen Filialen werden Dir 2%, ab 49€ ganze 4% und ab 99€ sogar 6% Deines Einkaufs auf Deiner ROMA Kundenkarte gutgeschrieben. Das heißt: Du kannst schon bald bei einem Besuch in unseren österreichischen Filialen Dein Guthaben einlösen und noch günstiger shoppen.</p>
				<p>Jetzt ganz einfach die Karte in Deiner Lieblingsfiliale holen und hier online aktivieren!</p>
				<img class="self-center rotate-[5deg] w-[460px]" src="/images/Kundekarte-Ocean-Freisteller-V2.png" alt="ROMA Kundenkarte"/>
			</div>
			<div class="flex justify-center items-center md:rotate-[-5deg]">
				<div class="relative">
					<video ref="cardTeaser" class="h-full max-h-[420px] md:max-h-screen md:h-[620px] object-cover object-center rounded-lg overflow-hidden" autoplay muted playsinline loop>
						<source src="videos/Kundekarte-Ocean-Feed-V1.webm" type="video/webm">
						<source src="videos/Kundekarte-Ocean-Feed-V1.ogm" type="video/ogm">
						<source src="videos/Kundekarte-Ocean-Feed-V1.mp4" type="video/mp4">
					</video>
					<span class="spininlate opacity-0 absolute bottom-0 left-0" @click="restartCardTeaser($event)"><i class="p-2 fa-light fa-rotate-left fa-2x text-gray-200 pointer-events-none"></i></span>
				</div>
			</div>
		</div>

		<div class="order-0 lg:order-1 w-full mx-auto">
			<div id="kundenkarte" class="w-full">
				<div class="card-outer flex flex-col md:flex-row">
					<div class="px-4 flex flex-col justify-between gap-4 flex-grow">
						<!-- card check form -->
						<div v-if="formStatus == 'cardcheck' || formStatus == 'cardcheck-signin'" class="grid grid-cols-1 md:grid-cols-2 gap-6">
							<div class="order-1 md:order-0 relative flex flex-col gap-y-4">
								<span class="z-[-1] absolute top-[10%] left-[41px] lg:left-[61px] w-[1px] h-[80%] bg-primary"></span>
								<div class="flex justify-center items-center gap-x-2">
									<span class="flex-grow">
										<img class="w-[100px] min-w-[100px] max-w-[100px] lg:w-[150px] lg:min-w-[150px] lg:max-w-[150px]" src="images/timeline-shop.png" alt="Karte in Deiner Lieblingsfiliale holen">
									</span>
									<span class="flex-shrink">
										<h4 class="font-sans font-bold text-xl">Karte in Deiner Lieblingsfiliale holen</h4>
										<p>Komm in Deiner Lieblingsfiliale vorbei und hol Dir Deine ROMA Kundenkarte</p>
									</span>
								</div>
								<div class="flex justify-center items-center gap-x-2">
									<span class="flex-grow">
										<img class="w-[100px] min-w-[100px] max-w-[100px] lg:w-[150px] lg:min-w-[150px] lg:max-w-[150px]" src="images/timeline-activate.png" alt="Karte online aktivieren">
									</span>
									<span class="flex-shrink">
										<h4 class="font-sans font-bold text-xl">Karte online aktivieren</h4>
										<p>Melde Dich hier mit wenigen Klicks online an und aktiviere Deine Kundenkarte.</p>
									</span>
								</div>
								<div class="flex justify-center items-center gap-x-2">
									<span class="flex-grow">
										<img class="w-[100px] min-w-[100px] max-w-[100px] lg:w-[150px] lg:min-w-[150px] lg:max-w-[150px]" src="images/timeline-collect.png" alt="Cashback sammeln">
									</span>
									<span class="flex-shrink">
										<h4 class="font-sans font-bold text-xl">Cashback sammeln</h4>
										<p>Sammle bei jedem Filialeinkauf unter Vorlage Deiner Kundenkarte 2%, ab 49€ ganze 4% und ab 99€ sogar 6% Cashback.</p>
									</span>
								</div>
								<div class="flex justify-center items-center gap-x-2">
									<span class="flex-grow">
										<img class="w-[100px] min-w-[100px] max-w-[100px] lg:w-[150px] lg:min-w-[150px] lg:max-w-[150px]" src="images/timeline-spend.png" alt="Cashback einlösen">
									</span>
									<span class="flex-shrink">
										<h4 class="font-sans font-bold text-xl">Cashback einlösen</h4>
										<p>Löse nach Verbuchung des Cashbacks ab dem darauffolgenden Monat Dein Guthaben bei Deinem nächsten Filialeinkauf ein und shoppe noch günstiger.</p>
									</span>
								</div>
							</div>
							<div class="order-0 md:order-1 flex flex-col">
								<div class="sticky top-0 pt-4">
									<form class="aspect-video p-6 rounded-lg grid grid-cols-12 gap-y-2 gap-x-4 bg-primary-light" method="post" @submit.prevent="sendCardCheckForm()">
										<h3 class="col-span-12 text-center text-xl">Hier Karte aktivieren</h3>
										<div class="col-span-12 flex flex-col justify-center items-center" :class="{'error': activationErrors.global != null}">
											<small class="errortext text-lg px-1 text-center text-red-700" v-if="activationErrors.global != null" v-html="activationErrors.global[0]"></small>
										</div>
										<div class="col-span-12 flex flex-col" :class="{'error': activationErrors.card_id != null}">
											<label class="pl-2 text-lg" for="user-signup-kundennr">Kundenkarten-Nummer<span class="text-red-700">*</span></label>
											<input v-model="activationData.card_id" type="number" name="kundennr" class="form-control" id="user-signup-kundennr" placeholder="123412341234123">
											<small class="errortext px-1 text-red-700" v-if="activationErrors.card_id != null">{{ activationErrors.card_id[0] }}</small>
										</div>
										<div class="col-span-12 flex flex-col" :class="{'error': activationErrors.pin != null}">
											<label class="pl-2 text-lg" for="user-signup-pin">Karten-Pin<span class="text-red-700">*</span></label>
											<input v-model="activationData.pin" type="password" name="pin" class="form-control" id="user-signup-pin" placeholder="••••">
											<small class="errortext px-1 text-red-700" v-if="activationErrors.pin != null">{{ activationErrors.pin[0] }}</small>
										</div>
										<div class="col-span-12 flex flex-col items-center gap-y-5">
											<button type="submit" :disabled="formStatus=='cardcheck-signin'" class="px-5 py-2 rounded bg-secondary text-white text-xl disabled:bg-gray-500">{{ formStatus=='cardcheck-signin' ? "Einloggen..." : "Anmelden" }} <i class="fal fa-check ml-2"></i></button>
										</div>
									</form>
								</div>
							</div>
						</div>

						<!-- Data Form -->
						<form class="rounded-lg self-center p-6 max-w-3xl grid grid-cols-12 gap-y-2 gap-x-4 bg-primary-light" method="post" @submit.prevent="sendActivationForm()" v-if="formStatus == 'fill' || formStatus == 'submit'">

							<div class="flex col-span-12 gap-2">
								<div class="overflow-hidden relative w-10 h-10 bg-gray-100 rounded-full dark:bg-gray-600">
										<svg class="absolute -left-1 w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
								</div>
								<div class="flex flex-col">
									<span>
										{{ signUpData.card_id }}
									</span>
									<span>
										<button type="button" @click.prevent="resetForm();" class="text-sm text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">Abmelden</button>
									</span>
								</div>
							</div>
							<div class="col-span-12 flex flex-col justify-center items-center" :class="{'error': formErrors.global != null}">
								<small class="errortext text-lg px-1 text-center text-red-700" v-if="formErrors.global != null" v-html="formErrors.global[0]"></small>
							</div>
							<div class="col-span-12 md:col-span-6 flex flex-col" :class="{'error': formErrors.firstname != null}">
								<label class="pl-2" for="user-signup-firstname">Vorname<span class="text-red-700">*</span></label>
								<input v-model="signUpData.firstname" type="text" name="firstname" class="form-control" id="user-signup-firstname" placeholder="Max">
								<small class="errortext px-1 text-red-700" v-if="formErrors.firstname != null">{{ formErrors.firstname[0] }}</small>
							</div>
							<div class="col-span-12 md:col-span-6 flex flex-col" :class="{'error': formErrors.lastname != null}">
								<label class="pl-2" for="user-signup-lastname">Nachname<span class="text-red-700">*</span></label>
								<input v-model="signUpData.lastname" type="text" name="lastname" class="form-control" id="user-signup-lastname" placeholder="Mustermann">
								<small class="errortext px-1 text-red-700" v-if="formErrors.lastname != null">{{ formErrors.lastname[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col" :class="{'error': formErrors.hairtradernr != null}">
								<label class="pl-2 flex gap-x-2" for="user-signup-hairtradernr">
									hairtrader-Kundennummer
									<div class="has-tooltip">
										<span class="tooltip rounded shadow-lg p-2 bg-primary-light -mt-16 left-[50px] text-sm pointer-events-none">Die Kundennummer Deines hairtrader-Accounts<br>(zu finden unter "Mein Konto" auf hairtrader.at)</span>
										<i class="fal fa-question-circle text-secondary"></i>
									</div>
								</label>
								<input v-model="signUpData.hairtradernr" type="number" name="hairtradernr" class="form-control" id="user-signup-hairtradernr" placeholder="2133999">
								<small class="errortext px-1 text-red-700" v-if="formErrors.hairtradernr != null">{{ formErrors.hairtradernr[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col" :class="{'error': formErrors.email != null}">
								<label class="pl-2" for="user-signup-email">Email<span class="text-red-700">*</span></label>
								<input v-model="signUpData.email" type="email" name="email" class="form-control" id="user-signup-email" placeholder="max@mustermann.at">
								<small class="errortext px-1 text-red-700" v-if="formErrors.email != null">{{ formErrors.email[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col" :class="{'error': formErrors.tel != null}">
								<label class="pl-2" for="user-signup-tel">Mobiltelefon</label>
								<input v-model="signUpData.tel" type="tel" name="tel" class="form-control" id="user-signup-tel" placeholder="+43 ### ### ## ##">
								<small class="errortext px-1 text-red-700" v-if="formErrors.tel != null">{{ formErrors.tel[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col" :class="{'error': formErrors.birthday != null}">
								<label class="pl-2 d-block" for="user-signup-birthday">Geburtsdatum</label>
								<!-- <input v-model="signUpData.birthday" type="date" name="birthday" class="form-control" id="user-signup-birthday" placeholder="TT.MM.YYYY"> -->
								<input
									class="bg-white"
									type="date"
									v-model="signUpData.birthday"
									name="birthday"
									id="user-signup-birthday"
									placeholder="TT.MM.JJJJ">
								<small class="errortext px-1 text-red-700" v-if="formErrors.birthday != null">{{ formErrors.birthday[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col">
								<label class="pl-2" for="inputStreet1">Adresszeile 1<span class="text-red-700">*</span></label>
								<input type="text" class="form-control" placeholder="Straße + Nummer" id="inputStreet1" v-model="signUpData.street1">
								<small class="errortext px-1 text-red-700" v-if="formErrors.street1 != null">{{ formErrors.street1[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col">
								<label class="pl-2" for="inputStreet2">Adresszeile 2</label>
								<input type="text" class="form-control" placeholder="Stiege, Haustür, Etage, ..." id="inputStreet2" v-model="signUpData.street2">
								<small class="errortext px-1 text-red-700" v-if="formErrors.street2 != null">{{ formErrors.street2[0] }}</small>
							</div>
							<div class="col-span-4 flex flex-col" :class="[{'error': formErrors.zip != null}]">
								<label class="pl-2" for="inputZip1">PLZ<span class="text-red-700">*</span></label>
								<input type="text" class="form-control" placeholder="####" id="inputZip1" v-model="signUpData.zip">
								<small class="errortext px-1 text-red-700" v-if="formErrors.zip != null">{{ formErrors.zip[0] }}</small>
							</div>
							<div class="col-span-8 flex flex-col" :class="[{'error': formErrors.city != null}]">
								<label class="pl-2" for="inputCity">Ort<span class="text-red-700">*</span></label>
								<input type="text" class="form-control" placeholder="Musterort" id="inputCity" v-model="signUpData.city">
								<small class="errortext px-1 text-red-700" v-if="formErrors.city != null">{{ formErrors.city[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col">
								<label class="pl-2" for="inputCountry1">Land<span class="text-red-700">*</span></label>
								<select id="selectCountry1" v-model="signUpData.country" class="form-input h-10 bg-white">
									<option :value="null" selected>Land wählen</option>
									<option value="Österreich">Österreich</option>
									<option value="Deutschland">Deutschland</option>
									<option value="Schweiz">Schweiz</option>
								</select>
								<small class="errortext px-1 text-red-700" v-if="formErrors.country != null">{{ formErrors.country[0] }}</small>
							</div>
							<div class="col-span-12 flex flex-col">
								<span class="flex gap-x-2">
									<input class="form-check-input" type="checkbox" id="user-signup-dataprotection" v-model="signUpData.dataprotection">
									<label class="d-block form-check-label" for="user-signup-dataprotection">
										<span class="cursor-pointer">Datenschutz<span class="text-red-700">*</span></span>
									</label>
								</span>
								<small class="errortext pl-5 text-red-700" v-if="formErrors.dataprotection != null">{{ formErrors.dataprotection[0] }}</small>
								<span class="pl-5 text-primary/80">
									Ich habe den <a href="https://roma.at/datenschutz-kundenkarte/" target="_blank"  class="underline">Datenschutzhinweis</a> gelesen und stimme der Verwendung meiner personenbezogenen Daten im dort beschriebenen Umfang zu.
								</span>
							</div>
							<div class="col-span-12 flex flex-col">
								<span class="flex gap-x-2">
									<input class="form-check-input" type="checkbox" id="user-signup-agbs" v-model="signUpData.agbs">
									<label class="d-block form-check-label" for="user-signup-agbs">
										<span class="cursor-pointer">Allgemeine Geschäftsbedingungen (AGB)<span class="text-red-700">*</span></span>
									</label>
								</span>
								<small class="errortext pl-5 text-red-700" v-if="formErrors.agbs != null">{{ formErrors.agbs[0] }}</small>
								<span class="pl-5 text-primary/80">
									Ich habe die <a href="https://roma.at/agb-kundenkarte/" target="_blank"  class="underline">allgemeinen Geschäftsbedingungen (AGB)</a>  gelesen und akzeptiert.
								</span>
							</div>
							<div class="col-span-12 flex flex-col items-center gap-y-5">
								<!-- <VueRecaptcha
									:sitekey="siteKey"
									:load-recaptcha-script="true"
									@verify="handleSuccess"
									@error="handleError"
								></VueRecaptcha>
								<small class="errortext px-1 text-red-700" v-if="formErrors.recaptcha != null">{{ formErrors.recaptcha[0] }}</small> -->
								<button type="submit" class="px-5 py-2 rounded bg-secondary text-white text-xl">Kundenkarte aktivieren <i class="fal fa-check ml-2"></i></button>
							</div>
						</form>

						<div v-if="formStatus == 'submit'" class="z-50 self-center max-w-3xl absolute submit-box top-0 w-full bottom-0 flex justify-center items-center">
							<div class="flex flex-col justify-center items-center gap-y-4">
								<i class="text-secondary fa-3x fa-light fa-spinner-third animate-spin"></i>
								<div class="text-lg font-bold text-center">Deine Daten werden gerade übermittelt,<br>wir bitten um einen kleinen Augenblick Geduld.</div>
							</div>
						</div>
						<div v-if="formStatus == 'success'">
							<div class="flex flex-col justify-center items-center py-44 gap-y-4">
								<i class="text-secondary fa-3x fa-light fa-check-circle"></i>
								<div class="text-primary text-lg font-bold text-center">
									Vielen Dank für die Aktivierung Deiner ROMA Kundenkarte!
									<br>
									Jetzt geht es los mit dem Sammeln des Cashbacks – damit Du noch günstiger bei uns einkaufen kannst.
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<div class="order-2 lg:order-2 px-4 flex flex-col">
			<h1 class="text-primary text-3xl font-serif mb-4">FAQs - Häufig gestellte Fragen</h1>
			<iCordionVue/>
		</div>
	</div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted } from 'vue'

import iCordionVue from '../modules/iCordion.vue';

// import { VueRecaptcha } from 'vue-recaptcha';
// const siteKey = computed(() => {
// 	return '6LffN0IiAAAAAK62eTeAM53PB8HqtnLgarrBbV-O';
// });

const formStatus = ref('cardcheck');

const activationData = ref({
	card_id: null,
	pin: null
});

const signUpData = ref({
	card_id: null,
	hairtradernr: null,
	email: null,
	firstname: null,
	lastname: null,
	tel: null,
	birthday: null,
	street1: null,
	street2: null,
	zip: null,
	city: null,
	country: null,
	dataprotection: false,
	agbs: false
});

// const recaptcha = ref(false);

const formErrors = ref([]);
const activationErrors = ref([]);

const cardTeaser = ref(null);

const resetForm = () => {
	console.log('resetForm');
	formStatus.value = 'cardcheck';
	signUpData.value.card_id = null;
	activationData.value.card_id = null;
	activationData.value.pin = null;
	activationErrors.value = [];
	formErrors.value = [];
}

const sendCardCheckForm = () => {
	formStatus.value = "cardcheck-signin";
	if (validateCheckForm()) {
		console.log('form is valid');
		axios.post('/api/checkuser', activationData.value)
			.then((response) => {
				console.log(response.data);
				if (response.data.status === "success") {
					if (response.data.user != null) {
						fillDataFromSignIn(response.data.user);
					} else {
						signUpData.value.card_id = activationData.value.card_id;
					}
					formStatus.value = 'fill';
				}
			})
			.catch((error) => {
				activationErrors.value.global = [error.response.data.message];
				formStatus.value = 'cardcheck';
			});
	} else {
		console.log('form is not valid');
		formStatus.value = 'cardcheck';
	}
}

const fillDataFromSignIn = (userData) => {
	signUpData.value.card_id = userData.card_id;
	signUpData.value.hairtradernr = userData.hairtradernr;
	signUpData.value.email = userData.email;
	signUpData.value.firstname = userData.firstname;
	signUpData.value.lastname = userData.lastname;
	signUpData.value.tel = userData.tel;
	signUpData.value.birthday = userData.birthday != null ? moment(userData.birthday).format('YYYY-MM-DD') : null;
	signUpData.value.street1 = userData.street1;
	signUpData.value.street2 = userData.street2;
	signUpData.value.zip = userData.zip;
	signUpData.value.city = userData.city;
	signUpData.value.country = userData.country;
	signUpData.value.dataprotection = userData.dataprotection == 1 ? true : false;
	signUpData.value.agbs = userData.agbs == 1 ? true : false;;
}

const sendActivationForm = () => {
	formStatus.value = 'submit';
	if (validateForm()) {
		console.log('form is valid');
		const timestamp = Date.now();
		axios.post('/api/storeuser', signUpData.value)
			.then((response) => {
				console.log(response.data);
				const timepassed = Date.now() - timestamp;
				console.log("timepassed", timepassed);
				if (response.data.status === "success") {
					// window.location.href = '/user/registration-success';
					if(timepassed < 5000) {
						setTimeout(() => {
							formStatus.value = 'success';
							scrollToFromTop();
						}, 5000 - timepassed);
					} else {
						formStatus.value = 'success';
						scrollToFromTop();
					}
				}
			})
			.catch((error) => {
				formErrors.value.global = [error.response.data.message];
				formStatus.value = 'fill';
			});
	} else {
		console.log('form is not valid');
		formStatus.value = 'fill';
	}
}

const scrollToFromTop = () => {
	const element = document.getElementById('kundenkarte');
	const y = element.getBoundingClientRect().top + window.pageYOffset;
	window.scrollTo({ top: y - 80, behavior: 'smooth' });
}

const validateCheckForm = () => {
	let isValid = true;
	// card_id validation
	if(activationData.value.card_id == null || activationData.value.card_id == '') {
		isValid = false;
		activationErrors.value.card_id = ['Bitte gib Deine Kundenkarten-Nr. ein.'];
	} else {
		activationErrors.value.card_id = null;
	}
	// lastname validation
	if(activationData.value.pin == null || activationData.value.pin == '') {
		isValid = false;
		activationErrors.value.pin = ['Bitte gib Deinen Karten-Pin ein.'];
	} else {
		activationErrors.value.pin = null;
	}

	return isValid;
}

const validateForm = () => {
	let isValid = true;
	if(signUpData.value.card_id == null || signUpData.value.card_id == '') {
		isValid = false;
		formErrors.value.global = ['Es scheint Du bist nicht angemeldet.'];
	} else {
		formErrors.value.global = null;
	}
	// firstname validation
	signUpData.value.firstname = signUpData.value.firstname.trim();
	if(signUpData.value.firstname == null || signUpData.value.firstname == '') {
		isValid = false;
		formErrors.value.firstname = ['Bitte gib Deinen Vornamen ein.'];
	} else {
		formErrors.value.firstname = null;
	}
	// lastname validation
	signUpData.value.lastname = signUpData.value.lastname.trim();
	if(signUpData.value.lastname == null || signUpData.value.lastname == '') {
		isValid = false;
		formErrors.value.lastname = ['Bitte gib Deinen Nachnamen ein.'];
	} else {
		formErrors.value.lastname = null;
	}
	// email validation
	signUpData.value.email = signUpData.value.email.trim();
	if (signUpData.value.email == null || signUpData.value.email == '' || signUpData.value.email.match(
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		) == null) {
		formErrors.value.email = ['Bitte gib eine gültige E-Mail Adresse ein.'];
		isValid = false;
	} else {
		formErrors.value.email = null;
	}
	// tel validation
	// if (signUpData.value.tel == null || signUpData.value.tel == '') {
	// 	formErrors.value.tel = ['Bitte geben Sie eine Telefonnummer ein.'];
	// 	isValid = false;
	// } else {
	// 	formErrors.value.tel = null;
	// }
	// street1 validation
	signUpData.value.street1 = signUpData.value.street1.trim();
	if(signUpData.value.street1 == null || signUpData.value.street1 == '') {
		isValid = false;
		formErrors.value.street1 = ['Bitte gib Deine Straße ein.'];
	} else {
		formErrors.value.street1 = null;
	}
	// zip validation
	signUpData.value.zip = signUpData.value.zip.trim();
	if(signUpData.value.zip == null || signUpData.value.zip == '') {
		isValid = false;
		formErrors.value.zip = ['Bitte gib Deine Postleitzahl ein.'];
	} else if (signUpData.value.zip.match(
		/^[0-9]*$/
		) == null) {
		isValid = false;
		formErrors.value.zip = ['Die Postleitzahl darf nur aus Zahlen bestehen.'];
	} else if (signUpData.value.zip.match(
		/^[0-9]{4,5}$/
		) == null) {
		isValid = false;
		formErrors.value.zip = ['Postleitzahl darf nur 4 oder 5 Zahlen lang sein.'];
	} else {
		formErrors.value.zip = null;
	}
	// city validation
	signUpData.value.city = signUpData.value.city.trim();
	if(signUpData.value.city == null || signUpData.value.city == '') {
		isValid = false;
		formErrors.value.city = ['Bitte gib Deine Stadt ein.'];
	} else {
		formErrors.value.city = null;
	}
	// country validation
	signUpData.value.country = signUpData.value.country.trim();
	if(signUpData.value.country == null || signUpData.value.country == '') {
		isValid = false;
		formErrors.value.country = ['Bitte gib Dein Land ein.'];
	} else {
		formErrors.value.country = null;
	}
	// dataprotection validation
	if(!signUpData.value.dataprotection) {
		isValid = false;
		formErrors.value.dataprotection = ['Bitte akzeptiere die Datenschutzbestimmungen.'];
	} else {
		formErrors.value.dataprotection = null;
	}
	// agbs validation
	if(!signUpData.value.agbs) {
		isValid = false;
		formErrors.value.agbs = ['Bitte akzeptiere die allgemeinen Geschäftsbedingungen (AGB).'];
	} else {
		formErrors.value.agbs = null;
	}
	// recaptcha validation
	// if(!recaptcha.value) {
	// 	isValid = false;
	// 	formErrors.value.recaptcha = ['Bitte bestätige, dass Du kein Roboter bist.'];
	// } else {
	// 	formErrors.value.recaptcha = null;
	// }

	return isValid;
}

// const handleError = () => {
// 	// Do some validation
// 	recaptcha.value = false;
// };

// const handleSuccess = (response) => {
// 	// Do some validation
// 	console.log(response);
// 	recaptcha.value = true;
// };

const restartCardTeaser = (event) => {
	cardTeaser.value.currentTime = 0;
	cardTeaser.value.play();
	event.target.classList.remove('spininlate');
	setTimeout(() => {
		event.target.classList.add('spininlate');
	}, 100);
}
</script>

<style lang="scss">
	form {
		@apply text-primary;
	}
	input, select {
		@apply px-4 py-2 border border-slate-300 rounded focus:outline-primary;
	}

	input.dp__input {
		@apply py-2 text-primary border border-slate-300 rounded focus:outline-primary;
	}


	.submit-box {
		@apply  bg-primary/80 text-white;
		@supports (backdrop-filter: blur(16px)) {
			@apply text-primary bg-primary/10 backdrop-filter backdrop-blur-sm transform-gpu;
		}
	}

	.spininlate {
		opacity: 0;
		animation-duration: .5s;
		animation-delay: 4.73s;
		animation-fill-mode: forwards;
  	animation-name: spinin-late;
	}


	@keyframes spinin-late {
		from {
			opacity: 0;
			rotate: 0deg;
		}

		to {
			opacity: 1;
			rotate: -360deg;
		}
	}

	.tooltip {
		@apply invisible absolute;
	}

	.has-tooltip:hover .tooltip {
		@apply visible z-50;
	}
</style>

